"use client";

import { Modal } from "@kyan/ui";

import { useShowWelcomeModal } from "#/store/app/portfolio/showWelcomeModal";

import { WelcomeModalContent } from "./components/WelcomeModalContent/WelcomeModalContent";

export const WelcomeModal: React.FC = () => {
  const { showWelcomeModal, setShowWelcomeModal } = useShowWelcomeModal();

  return (
    <Modal
      className="max-w-150"
      open={showWelcomeModal}
      onOpenChange={setShowWelcomeModal}
    >
      <WelcomeModalContent />
    </Modal>
  );
};
